import React from 'react';

function Footer() {
  return (
    <footer>
      <p>Lucas Mullen - © 2022 - All rights reserved.</p>
    </footer>
  );
}

export default Footer;
